import React, { useState } from 'react';
import { 
  Globe, 
  Settings, 
  RefreshCw, 
  History, 
  CheckCircle, 
  AlertCircle, 
  Download, 
  Upload, 
  Box, 
  ShoppingCart, 
  Percent,
  ChevronDown,
  ExternalLink
} from 'lucide-react';
import './CommonStyles.css';

const WoocommerceConnector = () => {
  const [activeTab, setActiveTab] = useState('settings');
  const [syncProgress, setSyncProgress] = useState({ active: false, type: '', percent: 0 });
  const [settings, setSettings] = useState({
    siteUrl: '',
    consumerKey: '',
    consumerSecret: '',
    autoSyncOrders: true,
    autoSyncProducts: false,
    syncOnUpdate: true
  });

  const [logs] = useState([
    { id: 1, type: 'Products', status: 'Success', message: 'Synced 45 products successfully', date: '2026-04-23 14:20:10' },
    { id: 2, type: 'Orders', status: 'Success', message: 'Synced 12 new orders', date: '2026-04-23 10:15:45' },
    { id: 3, type: 'Categories', status: 'Error', message: 'Connection timeout - check API credentials', date: '2026-04-22 18:05:22' }
  ]);

  const handleSync = (type) => {
    setSyncProgress({ active: true, type, percent: 0 });
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setSyncProgress(prev => ({ ...prev, percent: progress }));
      if (progress >= 100) {
        clearInterval(interval);
        setTimeout(() => setSyncProgress({ active: false, type: '', percent: 0 }), 1500);
      }
    }, 200);
  };

  const renderSettings = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', padding: '2rem' }}>
        <h3 style={{ margin: '0 0 1.5rem 0', display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '1.15rem' }}>
          <Settings size={20} color="var(--etpos-primary)" /> API Settings
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem', maxWidth: '600px' }}>
          <div>
            <label style={{ display: 'block', fontWeight: '700', marginBottom: '0.5rem', fontSize: '0.9rem' }}>WooCommerce Site URL:*</label>
            <input 
              type="text" 
              placeholder="https://yourstore.com" 
              value={settings.siteUrl} 
              onChange={e => setSettings({...settings, siteUrl: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '8px', fontSize: '0.95rem' }} 
            />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Consumer Key:*</label>
            <input 
              type="password" 
              placeholder="ck_xxxxxxxxxxxxxxxxxxxxxxxx" 
              value={settings.consumerKey} 
              onChange={e => setSettings({...settings, consumerKey: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '8px', fontSize: '0.95rem' }} 
            />
          </div>
          <div>
            <label style={{ display: 'block', fontWeight: '700', marginBottom: '0.5rem', fontSize: '0.9rem' }}>Consumer Secret:*</label>
            <input 
              type="password" 
              placeholder="cs_xxxxxxxxxxxxxxxxxxxxxxxx" 
              value={settings.consumerSecret} 
              onChange={e => setSettings({...settings, consumerSecret: e.target.value})}
              style={{ width: '100%', padding: '0.75rem', border: '1px solid var(--etpos-border)', borderRadius: '8px', fontSize: '0.95rem' }} 
            />
          </div>
        </div>
      </div>

      <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', padding: '2rem' }}>
        <h3 style={{ margin: '0 0 1.5rem 0', display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '1.15rem' }}>
          <RefreshCw size={20} color="#10b981" /> Sync Options
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {[
            { key: 'autoSyncOrders', label: 'Auto Sync Orders', desc: 'Sync orders from WooCommerce to POS automatically every 30 minutes' },
            { key: 'autoSyncProducts', label: 'Auto Sync Products', desc: 'Keep product quantities in sync across both platforms' },
            { key: 'syncOnUpdate', label: 'Sync on Update', desc: 'Update WooCommerce instantly when a product is edited in POS' }
          ].map(opt => (
            <div key={opt.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', background: 'var(--etpos-bg)', borderRadius: '8px' }}>
              <div>
                <p style={{ margin: 0, fontWeight: '700', fontSize: '0.95rem' }}>{opt.label}</p>
                <p style={{ margin: '0.2rem 0 0 0', fontSize: '0.8rem', color: 'var(--etpos-text-muted)' }}>{opt.desc}</p>
              </div>
              <input 
                type="checkbox" 
                checked={settings[opt.key]} 
                onChange={e => setSettings({...settings, [opt.key]: e.target.checked})}
                style={{ width: '1.3rem', height: '1.3rem', cursor: 'pointer' }}
              />
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
        <button style={{ background: 'var(--etpos-primary)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.85rem 4rem', fontWeight: '700', fontSize: '1rem', cursor: 'pointer' }}>Update Settings</button>
      </div>
    </div>
  );

  const renderSync = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      {syncProgress.active && (
        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '1.5rem', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <RefreshCw className="spin-animation" size={20} color="#3b82f6" />
              <span style={{ fontWeight: '700', fontSize: '1rem', color: '#1e40af' }}>Syncing {syncProgress.type}...</span>
            </div>
            <span style={{ fontWeight: '700', color: '#1e40af' }}>{syncProgress.percent}%</span>
          </div>
          <div style={{ width: '100%', height: '8px', background: '#dbeafe', borderRadius: '4px', overflow: 'hidden' }}>
            <div style={{ width: `${syncProgress.percent}%`, height: '100%', background: '#3b82f6', transition: 'width 0.3s ease' }} />
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {[
          { type: 'Categories', icon: <ChevronDown size={24} />, color: '#6366f1', count: '12 Categories found' },
          { type: 'Products', icon: <Box size={24} />, color: '#f59e0b', count: '145 Products found' },
          { type: 'Orders', icon: <ShoppingCart size={24} />, color: '#10b981', count: '89 Orders processed' }
        ].map(item => (
          <div key={item.type} style={{ background: 'var(--etpos-card)', borderRadius: '12px', border: '1px solid var(--etpos-border)', padding: '1.5rem', textAlign: 'center' }}>
            <div style={{ width: '60px', height: '60px', background: `${item.color}15`, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.25rem', color: item.color }}>
              {item.icon}
            </div>
            <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem', fontWeight: '700' }}>Sync {item.type}</h4>
            <p style={{ margin: '0 0 1.5rem 0', fontSize: '0.85rem', color: 'var(--etpos-text-muted)' }}>{item.count}</p>
            <button 
              onClick={() => handleSync(item.type)}
              disabled={syncProgress.active}
              style={{ width: '100%', padding: '0.75rem', background: item.color, color: 'white', border: 'none', borderRadius: '8px', fontWeight: '700', cursor: syncProgress.active ? 'not-allowed' : 'pointer' }}
            >
              Sync Now
            </button>
          </div>
        ))}
      </div>

      <div style={{ background: 'var(--etpos-bg)', borderRadius: '10px', padding: '1.5rem', border: '1px dashed var(--etpos-border)', textAlign: 'center' }}>
        <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--etpos-text-muted)' }}>
          <AlertCircle size={14} style={{ verticalAlign: 'middle', marginRight: '0.5rem' }} />
          Note: Syncing large catalogs may take several minutes. Do not close this window during the process.
        </p>
      </div>
    </div>
  );

  const renderTaxMapping = () => (
    <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', overflow: 'hidden' }}>
      <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700' }}>Tax Rate Mapping</h3>
        <button className="add-btn" style={{ padding: '0.6rem 1.25rem', fontSize: '0.875rem', borderRadius: '6px', background: '#3b82f6' }}>+ Add Mapping</button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="products-table" style={{ minWidth: '800px' }}>
          <thead>
            <tr>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em' }}>POS Tax Rate</th>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em' }}>WooCommerce Tax Class</th>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em', textAlign: 'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>GST 18%</td>
              <td>Standard</td>
              <td style={{ textAlign: 'right' }}><button className="action-btn-view">Edit</button></td>
            </tr>
            <tr>
              <td>VAT 5%</td>
              <td>Reduced Rate</td>
              <td style={{ textAlign: 'right' }}><button className="action-btn-view">Edit</button></td>
            </tr>
            <tr>
              <td>Zero Tax</td>
              <td>Zero Rate</td>
              <td style={{ textAlign: 'right' }}><button className="action-btn-view">Edit</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderLogs = () => (
    <div style={{ background: 'var(--etpos-card)', borderRadius: '10px', border: '1px solid var(--etpos-border)', overflow: 'hidden' }}>
      <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700' }}>Sync History</h3>
        <button className="export-btn" style={{ padding: '0.55rem 1rem', borderRadius: '6px' }}><Download size={14} /> Download Logs</button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table className="products-table" style={{ minWidth: '850px' }}>
          <thead>
            <tr>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em' }}>Type</th>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em' }}>Status</th>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em' }}>Message</th>
              <th style={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.025em', textAlign: 'right' }}>Date & Time</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id}>
                <td style={{ fontWeight: '600' }}>{log.type}</td>
                <td>
                  <span style={{ 
                    padding: '0.25rem 0.65rem', 
                    borderRadius: '12px', 
                    fontSize: '0.75rem', 
                    fontWeight: '700',
                    background: log.status === 'Success' ? '#ecfdf5' : '#fef2f2',
                    color: log.status === 'Success' ? '#10b981' : '#ef4444'
                  }}>
                    {log.status}
                  </span>
                </td>
                <td style={{ maxWidth: '400px', whiteSpace: 'normal', lineHeight: '1.4' }}>{log.message}</td>
                <td style={{ color: 'var(--etpos-text-muted)', textAlign: 'right' }}>{log.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="module-container">
      <div className="module-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{ background: '#6366f115', padding: '0.75rem', borderRadius: '12px', color: '#6366f1' }}>
            <Globe size={28} />
          </div>
          <div>
            <h2>WooCommerce Connector</h2>
            <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--etpos-text-muted)' }}>Sync your inventory and orders seamlessly</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button className="export-btn"><ExternalLink size={14} /> Visit Store</button>
          <button className="add-btn" onClick={() => handleSync('All Data')}>
            <RefreshCw size={14} className={syncProgress.active ? 'spin-animation' : ''} /> Full Sync
          </button>
        </div>
      </div>

      <div className="module-tabs">
        {[
          { id: 'settings', label: 'API Settings', icon: <Settings size={14} /> },
          { id: 'sync', label: 'Sync Center', icon: <RefreshCw size={14} /> },
          { id: 'tax', label: 'Tax Mapping', icon: <Percent size={14} /> },
          { id: 'logs', label: 'Sync Logs', icon: <History size={14} /> }
        ].map(tab => (
          <button 
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <div className="module-content" style={{ padding: '0.5rem', background: 'transparent', border: 'none', boxShadow: 'none' }}>
        {activeTab === 'settings' && renderSettings()}
        {activeTab === 'sync' && renderSync()}
        {activeTab === 'tax' && renderTaxMapping()}
        {activeTab === 'logs' && renderLogs()}
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .spin-animation {
          animation: spin 2s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}} />
    </div>
  );
};

export default WoocommerceConnector;
